import { useEffect, useState } from 'react';
import { settingsService, AiModelsResponse } from '@/services/settings.service';

let cache: AiModelsResponse | null = null;
let inflight: Promise<AiModelsResponse> | null = null;
const listeners = new Set<(d: AiModelsResponse) => void>();

function broadcast(d: AiModelsResponse) {
  cache = d;
  listeners.forEach((l) => l(d));
}

async function fetchOnce(): Promise<AiModelsResponse> {
  if (cache) return cache;
  if (inflight) return inflight;
  inflight = settingsService.listAiModels().then((d) => { broadcast(d); inflight = null; return d; });
  return inflight;
}

/** Force re-fetch (e.g. after a key is added or default changed). */
export function invalidateAiModels(): Promise<void> {
  cache = null;
  return settingsService.listAiModels().then(broadcast);
}

export function useAiModels(): { data: AiModelsResponse | null; loading: boolean } {
  const [data, setData] = useState<AiModelsResponse | null>(cache);
  const [loading, setLoading] = useState<boolean>(cache === null);

  useEffect(() => {
    const onChange = (d: AiModelsResponse) => setData(d);
    listeners.add(onChange);
    if (!cache) {
      setLoading(true);
      fetchOnce().finally(() => setLoading(false));
    }
    return () => { listeners.delete(onChange); };
  }, []);

  return { data, loading };
}
